import { render, staticRenderFns } from "./SustainabilityCompass.vue?vue&type=template&id=28a22572&scoped=true&"
import script from "./SustainabilityCompass.vue?vue&type=script&lang=ts&"
export * from "./SustainabilityCompass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a22572",
  null
  
)

export default component.exports